export const createAuditEntry = (userEmail, action, details = "") => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
  action,
  details,
  user: userEmail || "unknown",
  timestamp: new Date().toISOString(),
});
